
// SVG Icon: timeline
export default { id: "terriajs-timeline" };
export const id = "terriajs-timeline";
export const name = "timeline";
